<app-search [name]="name"
            [formName]="formName"
            [(data)]="data"
            [views]="views"
            [apiController]="apiController"
            [keyFieldName]="keyFieldName"
            [toolbarItems]="toolbarItems"
            [gridSettings]="gridSettings"
            [includeAddButton]="false">

</app-search>
